import { render, staticRenderFns } from "./fav.vue?vue&type=template&id=f42cdef2"
import script from "./fav.vue?vue&type=script&lang=js"
export * from "./fav.vue?vue&type=script&lang=js"
import style0 from "./fav.vue?vue&type=style&index=0&id=f42cdef2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports